export default __webpack_public_path__ + "locales/uk-UA/OAuth.json?hash=0d0b089252265514a7fba403fb3edc90";